<template>
  <div class="training-details-wrap">
    <v-btn text @click="$router.go(-1)" style="margin-left: -16px;">
        <v-icon left>mdi-chevron-left</v-icon>
        Back
    </v-btn>
    <div class="mb-7 mt-3 d-flex flex-wrap">
        <h2 class="headline">Training Details</h2>
        <v-spacer></v-spacer>
        <div style="margin-left: -4px; margin-right: -4px;">
          <v-btn
            v-if="item && item.status !== 'approved'"
            @click="$root.$emit('ApproveTraining', item)"
            color="success"
            class="mx-1 mb-1"
          >
            <v-icon left>mdi-briefcase-check</v-icon>
            Approve
          </v-btn>
          <v-btn 
            v-if="!loading"
            @click="$root.$emit('EditTraining', {...item, category_ids: topics.map(i => i.id)})"
            color="success"
            class="mx-1 mb-1"
          >
            <v-icon left>mdi-pencil</v-icon>
            Edit
          </v-btn>
          <template v-else>
            <v-skeleton-loader
              type="button"
              class="mx-1 mb-1 d-inline-flex"
            ></v-skeleton-loader>
          </template>
          <v-btn 
            v-if="!loading"
            @click="$root.$emit('DeleteTraining', item)"
            color="error"
            class="mx-1 mb-1"
          >
            <v-icon left>mdi-delete</v-icon>
            Delete
          </v-btn>
          <template v-else>
            <v-skeleton-loader
              type="button"
              class="mx-1 mb-1 d-inline-flex"
            ></v-skeleton-loader>
          </template>
        </div>
    </div>
    <v-card v-if="!loading">
      <v-simple-table v-if="!no_data.includes(item)" :loading="loading" v-slot:default>
        <template>
          <thead>
            <tr>
              <th class="text-left">Details</th>
              <th class="text-left"></th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Title</td>
              <td>
                <span v-if="!no_data.includes(item.title)">{{ item.title }}</span>
                <em v-else class="grey--text">No data</em>
              </td>
            </tr>
            <tr>
              <td>Description</td>
              <td>
                <span v-if="!no_data.includes(item.description)">{{ item.description }}</span>
                <em v-else class="grey--text">No data</em>
              </td>
            </tr>
            <tr>
              <td>Status</td>
              <td>
                <span v-if="!no_data.includes(item.status)">{{ titleCase(item.status) }}</span>
                <em v-else class="grey--text">No data</em>
              </td>
            </tr>
            <tr>
              <td>Date From</td>
              <td>
                <span v-if="!no_data.includes(item.date_from)">{{ item.date_from }}</span>
                <em v-else class="grey--text">No data</em>
              </td>
            </tr>
            <tr>
              <td>Date To</td>
              <td>
                <span v-if="!no_data.includes(item.date_to)">{{ item.date_to }}</span>
                <em v-else class="grey--text">No data</em>
              </td>
            </tr>
            <tr>
              <td>Contact Email</td>
              <td>
                <span v-if="!no_data.includes(item.contact_email)">{{ item.contact_email }}</span>
                <em v-else class="grey--text">No data</em>
              </td>
            </tr>
            <tr>
              <td>Contact Phone</td>
              <td>
                <span v-if="!no_data.includes(item.contact_phone)">{{ item.contact_phone }}</span>
                <em v-else class="grey--text">No data</em>
              </td>
            </tr>
            <tr>
              <td>Online Training Only</td>
              <td>
                <span v-if="!no_data.includes(item.not_have_location)">{{ Boolean(item.not_have_location) ? 'Yes' : 'No' }}</span>
                <em v-else class="grey--text">No data</em>
              </td>
            </tr>
            <template v-if="!item.not_have_location">
              <tr>
                <td>Address</td>
                <td>
                  <span v-if="!no_data.includes(item.address)">{{ item.address }}</span>
                  <em v-else class="grey--text">No data</em>
                </td>
              </tr>
              <tr>
                <td>City</td>
                <td>
                  <span v-if="!no_data.includes(item.city)">{{ item.city }}</span>
                  <em v-else class="grey--text">No data</em>
                </td>
              </tr>
              <tr>
                <td>State</td>
                <td>
                  <span v-if="!no_data.includes(item.state)">{{ item.state }}</span>
                  <em v-else class="grey--text">No data</em>
                </td>
              </tr>
              <tr>
                <td>Location</td>
                <td>
                  <span v-if="!no_data.includes(item.location)">{{ item.location }}</span>
                  <em v-else class="grey--text">No data</em>
                </td>
              </tr>
            </template>
            <template v-else>
              <tr>
                <td>Website</td>
                <td>
                  <span v-if="!no_data.includes(item.website)">{{ item.website }}</span>
                  <em v-else class="grey--text">No data</em>
                </td>
              </tr>
            </template>
          </tbody>
        </template>
      </v-simple-table>
      </v-card>
      <template v-else>
        <v-skeleton-loader
          type="paragraph"
          class="mx-auto mb-4"
        ></v-skeleton-loader>
        <v-skeleton-loader
          type="paragraph"
          class="mx-auto"
        ></v-skeleton-loader>
      </template>
      <div v-if="!loading" class="mb-5">
        <div class="mb-2 mt-7 d-flex flex-wrap">
          <h2 class="title">Training Topics</h2>
        </div>
        <template v-if="!no_data.includes(topics) && topics.length > 0">
          <v-chip
            v-for="item in topics"
            :key="item.id"
            class="my-1 mr-2"
            color="primary"
          >
            {{ decodeHTMLEntities(item.name) }}
          </v-chip>
        </template>
        <div v-else class="body-2 mb-3 grey--text">
          There are no selected training topics.
        </div>
      </div>
    <approve-training @done="initialize"></approve-training>
    <edit-training @done="initialize"></edit-training>
    <delete-training @done="$router.push(`/advertiser/${$route.params.organization_id}/${$route.params.organization_name}/trainings`)"></delete-training>
  </div>
</template>

<script>
import ApiService from "@/common/api.service"
import ApproveTraining from "./ApproveTraining"
import DeleteTraining from "./DeleteTraining"
import EditTraining from "./EditTraining"

export default {
  name: 'TrainingDetails',
  components: {
    ApproveTraining,
    DeleteTraining,
    EditTraining
  },
  data: () => ({
    no_data: [null, "", undefined, "null"],
    topics: [],
    item: null,
    loading: false,
  }),
  mounted() {
    this.initialize()
  },
  methods: {
    initialize() {
      this.loading = true;
      ApiService.get(`/admin/training/${this.$route.params.id}/show`, {organization_id: this.$route.params.organization_id})
        .then(response => {
          this.item = response.data.training
          this.topics = response.data.training_topics
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          console.log(error.message);
        });
    },
    titleCase(str){
      return _.startCase(str.replace(/_/g, ' '))
    },
    decodeHTMLEntities(i) {
      return _.unescape(i)
    }
  }
}
</script>
